export default [
  {
    path: '/main/acessories',
    meta: {
      tag: 'list_acessories',
      name: 'Acessórios',
      breadcrumb: 'Acessórios'
    },
    component: () => import(/* webpackChunkName: "acessories-list" */ '@/views/main/settings/test-registers/acessories/Index.vue'),
    children: [
      {
        path: '',
        name: 'listacessories',
        meta: {
          tag: 'list_acessories',
          menu: 'settings',
          name: 'Acessórios'
        },
        component: () => import(/* webpackChunkName: "acessories-list" */ '@/views/main/settings/test-registers/acessories/List.vue')
      },
      {
        path: '/main/acessories/add',
        name: 'addacessory',
        meta: {
          tag: 'add_acessory',
          menu: 'settings',
          name: 'Adicionar | Acessório',
          breadcrumb: 'Adicionar Acessório'
        },
        component: () => import(/* webpackChunkName: "acessories-add" */ '@/views/main/settings/test-registers/acessories/Add.vue')
      },
      {
        path: '/main/acessories/:id',
        name: 'editacessory',
        meta: {
          tag: 'edit_acessory',
          menu: 'settings',
          name: 'Editar | Acessório',
          breadcrumb: 'Editar Acessório'
        },
        component: () => import(/* webpackChunkName: "acessories-edit" */ '@/views/main/settings/test-registers/acessories/Edit.vue')
      }
    ]
  },
]
